import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Paper,
  Stack,
  Typography,
  Alert,
} from '@mui/material';
import { configService } from '../config/index';

/**
 * Pantalla de estado de Convex: comprueba conexión y muestra configuración básica.
 * Estado de conexión a Convex.
 */
const ConvexConfig: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [connected, setConnected] = useState<boolean | null>(null);
  const [notificationEmail, setNotificationEmail] = useState<string | null>(null);

  const checkConvex = async () => {
    try {
      setLoading(true);
      setError(null);
      const email = await configService.getNotificationEmail();
      setNotificationEmail(email ?? null);
      setConnected(true);
    } catch (err) {
      setConnected(false);
      setError(err instanceof Error ? err.message : 'Error al conectar con Convex');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkConvex();
  }, []);

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" gutterBottom>
        Estado de Convex
      </Typography>

      <Paper sx={{ p: 3, mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Conexión a la base de datos
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Esta aplicación usa Convex como base de datos. Aquí puedes comprobar el estado de la conexión.
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Stack spacing={2}>
          <Box display="flex" alignItems="center" gap={2}>
            <Typography variant="body1">Estado:</Typography>
            {loading ? (
              <CircularProgress size={24} />
            ) : connected ? (
              <Alert severity="success" sx={{ py: 0 }}>
                Conectado a Convex
              </Alert>
            ) : (
              <Alert severity="error" sx={{ py: 0 }}>
                Error de conexión
              </Alert>
            )}
          </Box>
          {notificationEmail !== undefined && (
            <Typography variant="body2" color="text.secondary">
              Email de notificación configurado: {notificationEmail ?? '(no configurado)'}
            </Typography>
          )}
          <Button variant="contained" color="primary" onClick={checkConvex} disabled={loading}>
            Comprobar conexión
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
};

export default ConvexConfig;
